var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('sidebar',{staticClass:"sidebar",attrs:{"sidebarWidth":_vm.sidebarWidth}})],1),_c('el-container',[_c('el-header',{staticClass:"header"},[_c('breadcrumb',{on:{"clickNavbar":_vm.clickI}})],1),_c('el-main',{staticClass:"main"},[_c('appMain')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }